"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Row = _interopRequireDefault(require("./Row"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Header = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Row.default, {
      children: _react.default.Children.map(children, child =>
      /*#__PURE__*/
      // TO DO: pass type as a variant instead of prop
      _react.default.cloneElement(child, {
        type: 'heading'
      }))
    })
  });
});
Header.displayName = 'Header';
Header.propTypes = {
  children: _propTypes.default.node
};
var _default = exports.default = Header;